import { Box, Typography } from "@mui/material";
import React from "react";
import Knowmorebtn from "../../components/button/Knowmorebtn";
import CardImageOne from "../../assets/images/Expertise01Image.png";

const CaseStudiesCard = ({ title, id, link, image, description }) => {
  return (
    <Box
      sx={{
        width: { xs: "40rem", sm: "26rem" },
        height: { xs: "33rem", sm: "31rem" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
        }}
      >
        <Box
          sx={{
            width: "70%",
            height: { xs: "8rem", sm: "10rem" },
            backgroundColor: "white",
            borderRadius: "1rem",
          }}
        ></Box>
        <Box
          sx={{
            position: "absolute",
            top: { xs: "8%", sm: "8%" },
            left: "2%",
            width: "100%",
            height: { xs: "16rem", sm: "20rem" }, // Set a fixed height for consistency
            borderRadius: "1rem",
            overflow: "hidden",
            border: "5px solid #ffffff",
          }}
        >
          <img
            src={image}
            alt=""
            width="100%"
            height="100%"
            style={{
              objectFit: "cover",
              objectPosition:
                title === "Crystal Ball Forecasting" ? "center" : "bottom",
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: { xs: "8.5rem", sm: "11.5rem" },
          paddingLeft: { xs: "0.6rem", sm: "0.6rem" },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1.2rem",
            fontWeight: "600",
            marginTop: "1rem",
            paddingTop: { xs: "0.5rem", sm: "0rem" },
          }}
        >
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>{title}</span>
        </Typography>

        {title === "Crystal Ball Forecasting" && (
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontSize: "0.92rem",
              fontWeight: "500",
              marginTop: "1rem",
              border: "2px solid rgba(255,102,0,1)",
              padding: "0.3rem 1rem",
            }}
          >
            MRSI Golden Key Awards 2024 Finalist
          </Typography>
        )}

        <Typography
          sx={{
            marginTop: "1rem",
            color: "rgba(51, 51, 51, 1)",
            fontFamily: "Montserrat",
            flexGrow: 1,
          }}
        >
          {description}{" "}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: { xs: "0rem 0rem", sm: "0rem 0rem" },
            marginTop: id === 2 ? { xs: "1rem", sm: "1.7rem" } : "1rem",
            fontFamily: "Montserrat",
          }}
        >
          <Knowmorebtn content="Read More" link={link} />
        </Box>
      </Box>
    </Box>
  );
};

export default CaseStudiesCard;
